<template>
  <div class="homeheader_ad_main">
    <el-row>
      <el-col :span="3">
        <div class="homeheader_ad_login">
          <img :src="m4tlogo.photo1" />
        </div>
      </el-col>
      <el-col :span="17">
        <div class="homeheader_ad_menu">
          <ul>
            <li>
              <router-link to="/loginbf">首页</router-link>
            </li>
            <li>
              <router-link to="/recommend">专题策划</router-link>
            </li>
            <li>
              <router-link to="/service">增值服务</router-link>
            </li>
            <li>
              <router-link to="/aboutus">关于我们</router-link>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="homeheader_ad_btn" v-if="!userInfo">
          <span class="iconfont icon-Shapecopy"></span>
          <span>
            <router-link class="login-left" to="/login">登录</router-link>
          </span>
          <span>/</span>
          <span>
            <router-link class="login-right" to="/register">注册</router-link>
          </span>
        </div>
        <div class="userPerson userInfoad">
          <el-dropdown trigger="click" placement="top" v-if="userInfo">
            <div class="personLogo">
              <span
                >{{ userInfo.user_name }}
                <i class="el-icon-arrow-down"></i>
              </span>
              <a class="userHead">
                <img :src="userInfo.img_path" alt="" />
              </a>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span @click="toPersonal">个人中心</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="signOut">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import homeHeaderAd from "../components/homeHeaderAd.vue"; //头部
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import searchAndselect from "../components/searchAndselect"; //搜索框
import { mapGetters, mapActions } from "vuex";
import { getModuleInfo, signOut } from "./../services/api.js";
export default {
  components: {
    homeHeaderAd, //广告头
    homeFooterAd, //广告底
    searchAndselect //搜索框
  },
  data() {
    return {
      select: "",
      moduleIds: [13],
      m4tlogo: {}
    };
  },
  mounted() {
    this.getMInfo();
  },
  computed: {
    ...mapGetters(["webModels", "webID"]),
    userInfo() {
      return sessionStorage.getItem("user")
        ? JSON.parse(sessionStorage.getItem("user"))
        : false;
    }
  },
  methods: {
    toPersonal() {
      this.$router.push({ path: "/personal" });
    },
    signOut() {
      signOut().then(res => {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");

        window.location.href = "https://login.ihep.ac.cn/logout";
      });
    },
    getMInfo() {
      let data = {
        module_id: 4,
        web_id: this.webID
      };
      getModuleInfo(data).then(res => {
        if (res.status_code == 1) {
          if (res.data.list.length > 0) {
            this.m4tlogo = res.data.list[0];
          }
        }
      });
    }
  }
};
</script>
<style lang="less">
.userInfoad {
  position: absolute;
  // width: 300px;
  height: 100%;
  right: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  span {
    font-size: 16px;
    line-height: 45px;
    cursor: pointer;
    vertical-align: middle;
  }
  .userHead {
    margin-left: 10px;
    display: inline-block;
    width: 45px;
    height: 45px;
    vertical-align: middle;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
.homeheader_ad_main {
  height: 100%;
  width: 100%;
  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      display: table;
      .homeheader_ad_login {
        height: 60px;
        margin-left: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .homeheader_ad_menu {
        display: table-cell;
        vertical-align: middle;
        overflow: auto;
        ul {
          float: right;
          display: block;
          overflow: hidden;
          white-space: nowrap;
          li {
            list-style: none;
            display: inline-block;
            margin-left: 20px;
          }
        }
      }
      .homeheader_ad_btn {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        span {
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeHeaderAd.vue